export default {
    namespaced: true,
    modules: {
        metadata: require("./metadata").default,
    },
    state: {
    },
};


// WEBPACK FOOTER //
// src/store/tool/file/index.js